// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {};

// App Breakpoints
export const $themeBreakpoints = {};

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: 'حسبة',
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/newLogo/hasba/logo-white.png'),
    // eslint-disable-next-line global-require
    logoTwo: require('@/assets/images/newLogo/hasba/logo-white.png'),
    // eslint-disable-next-line global-require
    logoFull: require('@/assets/images/newLogo/hasba/logo-full.png'),
    // eslint-disable-next-line global-require
    logoIcon: require('@/assets/images/newLogo/hasba/icon-white.png'),
    // eslint-disable-next-line global-require
    logoIconDark: require('@/assets/images/newLogo/hasba/icon.png'),
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'static', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'hidden', // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: false,
  },
};
